import { useCreatePlan } from "@/hooks/requests/plan/use-create-plan";
import { useToast } from "@/hooks/ui/use-toast";
import { recreatePlanInvalidateQueries } from "@/utils/query/invalidate";
import { IonAlert } from "@ionic/react";
import { useQueryClient } from "@tanstack/react-query";

interface RecreatePlanAlertProps {
  isOpen: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
}

export const RecreatePlanAlert = ({
  isOpen,
  onCancel,
  onConfirm,
}: RecreatePlanAlertProps) => {
  const queryClient = useQueryClient();
  const { updatePlanAsync, isLoading } = useCreatePlan();
  const { showError } = useToast();
  const handleRecreatePlan = async () => {
    try {
      await updatePlanAsync();
      recreatePlanInvalidateQueries(queryClient);
      onConfirm();
    } catch (error) {
      onCancel?.();
      if (error instanceof Error) {
        showError(error.message);
      } else {
        showError("An unknown error occurred: " + error);
      }
    }
  };
  return (
    <IonAlert
      isOpen={isOpen}
      header="Do you want to create a new plan now?"
      mode="ios"
      buttons={[
        {
          text: "No",
          role: "cancel",
          handler: () => {
            onCancel?.();
          },
        },
        {
          text: isLoading ? "Recreating..." : "Yes",
          role: "confirm",
          handler: handleRecreatePlan,
        },
      ]}
      onDidDismiss={({ detail }) => {
        console.log(detail);
      }}
    />
  );
};
